export default {
    PAGE: {
        QUALITAETSWEINPRUEFUNG: {
            EILVERFAHREN: '/qualitaetsweinpruefung/eilverfahren',
        },
    },
    API: {
        EILVERFAHREN: '/eilverfahren/:betrieb_nr',
    },
};
